import { Trash01 } from "@untitledui/icons"
import { DesignDialog } from "@/components/ui/design-dialog"

interface DeleteDealershipDialogProps {
  dealershipName: string | null
  groupName: string | null
  loading: boolean
  onClose: () => void
  onConfirm: () => void
}

// Destructive confirmation for DELETE /v1/teams/:groupId/group/dealerships/:dealershipId.
// Open shape mirrors RemoveMemberDialog so the destructive vocabulary stays
// consistent across Settings.
export function DeleteDealershipDialog({
  dealershipName,
  groupName,
  loading,
  onClose,
  onConfirm,
}: DeleteDealershipDialogProps) {
  const open = !!dealershipName
  return (
    <DesignDialog.Root open={open} onOpenChange={(v) => !v && onClose()}>
      <DesignDialog.Content width="md">
        <DesignDialog.Header>
          <DesignDialog.Title>Remove this dealership?</DesignDialog.Title>
          <DesignDialog.Description>
            <span className="font-semibold text-zinc-700">{dealershipName ?? ""}</span>{" "}
            will be removed from{" "}
            <span className="font-semibold text-zinc-700">{groupName ?? "your group"}</span>.
            Members will lose access to it. Estimates already created stay where they are.
          </DesignDialog.Description>
        </DesignDialog.Header>
        <DesignDialog.Footer>
          <DesignDialog.Close asChild>
            <button
              type="button"
              className="h-12 px-5 rounded-xl text-[14px] font-semibold text-zinc-600 hover:text-zinc-900 hover:bg-zinc-100 transition-all duration-150"
            >
              Cancel
            </button>
          </DesignDialog.Close>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className="h-12 px-7 inline-flex items-center gap-2 rounded-xl bg-red-600 text-white text-[15px] font-semibold shadow-lg shadow-red-600/20 hover:bg-red-700 hover:shadow-red-600/30 transition-all duration-150 disabled:opacity-40 disabled:cursor-not-allowed disabled:shadow-none"
          >
            <Trash01 className="size-4" aria-hidden />
            {loading ? "Removing…" : "Remove dealership"}
          </button>
        </DesignDialog.Footer>
      </DesignDialog.Content>
    </DesignDialog.Root>
  )
}
